module.exports = __webpack_public_path__ + "img/ANT.547bb48e.svg";